const LoqateMoreClose = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            width="5"
            height="5"
            viewBox="0 0 10 10"
            {...props}
        >
            <path stroke="#000" strokeLinecap="round" d="M9 1L1 9m0-8l8 8" />
        </svg>
    )
}

export default LoqateMoreClose
